"use client"

import { create } from "zustand"
import type { Assertion } from "@/server/services/playground"

interface SandboxSessionState {
    sandboxSessionId: string | null
    expiresAt: number | null
    assertions: Assertion[]
    startSandboxSession: (sandboxSessionId: string) => void
    setExpiresAt: (expiresAt: number | null) => void
    endSandboxSession: () => void
    setAssertions: (assertions: Assertion[]) => void
    registerLiveChatAbort: (
        instanceId: string,
        abort: (() => Promise<void>) | null
    ) => void
    cancelLiveChatRuns: () => Promise<void>
}

const liveChatAborts = new Map<string, () => Promise<void>>()

export const useSandboxSessionStore = create<SandboxSessionState>()(set => ({
    sandboxSessionId: null,
    expiresAt: null,
    assertions: [],
    startSandboxSession: sandboxSessionId => set({ sandboxSessionId }),
    setExpiresAt: expiresAt => set({ expiresAt }),
    endSandboxSession: () =>
        set({
            sandboxSessionId: null,
            expiresAt: null,
            assertions: [],
        }),
    setAssertions: assertions => set({ assertions }),
    registerLiveChatAbort: (instanceId, abort) => {
        if (abort) liveChatAborts.set(instanceId, abort)
        else liveChatAborts.delete(instanceId)
    },
    cancelLiveChatRuns: async () => {
        await Promise.all(
            Array.from(liveChatAborts.values()).map(abort => abort())
        )
    },
}))
